import { useSelector } from 'react-redux';
import { StateWithEmergencyCalls } from '@rsos/reduxDataStore/src/features/emergencyCalls/emergencyCallsSlice';
import { isFordCallerID } from '@rsos/utils/isFordCallerID';

/**
 * True when the given (or currently selected) caller is a Ford VIN-keyed
 * crash/location row. Used to suppress phone-centric actions and swap labels.
 */
const useIsFordCall = (callerID?: string | null): boolean => {
  const selectedCallerID = useSelector(
    (state: StateWithEmergencyCalls) => state.emergencyCalls.selectedCallerID,
  );
  const callQueue = useSelector(
    (state: StateWithEmergencyCalls) => state.emergencyCalls.callQueue,
  );
  const resolvedCallerID = callerID || selectedCallerID;

  return isFordCallerID(callQueue, resolvedCallerID);
};

export default useIsFordCall;
